import { createEffect, createEvent, type Store, sample } from 'effector'

import { createHideFx } from '@/shared/ui/modal'

export const backButtonClicked = createEvent()

export const showFx = createEffect<
    {
        email: string
        onConfirm: () => void
        $disableSubmitButton?: Store<boolean>
    },
    string
>()
export const hideFx = createHideFx(showFx)

sample({
    clock: backButtonClicked,
    target: hideFx,
})
